import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setPromoCode = payload =>
  call(websocketFetch, 'set_promo_code', payload);
